// extracted by mini-css-extract-plugin
export default {"root":"BadgeNew_root--XhF","text":"BadgeNew_text--HyC"};